<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Being born and bred in Dublin in the 1970s taught Redmond to start each day with a smile, as it improved the odds of going to bed with one. His mother’s deep sense of spiritualism combined with his father’s military discipline gave him a level head, which has served him well over the last thirty years in both the security and healthcare sectors. It was his maternal grandmother, however, who fed his imagination, as the fire she read and let him play with for endless hours was the birthplace of what would become <em>Tears of Gold.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5ef88680